let brName = "";

export const getBrowserName = () => {
  if (brName !== "") {
    return brName;
  } else {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.match(/chrome|chromium|crios/i)) {
      brName = "chrome";
    } else if (userAgent.match(/firefox|fxios/i)) {
      brName = "firefox";
    } else if (userAgent.match(/safari/i)) {
      brName = "safari";
    } else if (userAgent.match(/opr\//i)) {
      brName = "opera";
    } else if (userAgent.match(/edg/i)) {
      brName = "edge";
    } else {
      brName = "other";
    }
    return brName;
  }
};
